import { Model } from 'modules/core/lib/mobx-rest'

interface IContractVersionPayrollPolicy {
  [key: string]: any
}

class ContractVersionPayrollPolicy extends Model<IContractVersionPayrollPolicy> {
  static urlRoot() {
    return '/contracts/payroll_policies'
  }

  remove() {
    return this.rpc('remove')
  }
}

export default ContractVersionPayrollPolicy
